export const initialFilterState = {
  filterByCategory: "DSLR",
  filterByBrands: [],
  filterByRatings: "",
  filterByPriceRange: 150000,
  sortBy: "",
};
